import { useRef } from "react";
import { Upload, X, ImagePlus } from "lucide-react";
import { fileToBase64 } from "@/lib/format";
import { toast } from "sonner";
import { Label } from "@/components/ui/label";

export function ImageUpload({ label, value, onChange, testid }) {
  const ref = useRef();
  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      const b64 = await fileToBase64(file);
      onChange(b64);
    } catch (err) {
      toast.error(err.message);
    }
  };
  return (
    <div>
      <Label>{label}</Label>
      <div className="mt-1 flex items-center gap-3">
        <div className="h-16 w-16 rounded-lg border border-slate-200 bg-slate-50 flex items-center justify-center overflow-hidden shrink-0">
          {value ? (
            <img src={value} alt={label} className="h-full w-full object-cover" />
          ) : (
            <ImagePlus className="h-6 w-6 text-slate-300" />
          )}
        </div>
        <div className="flex items-center gap-2">
          <button type="button" onClick={() => ref.current?.click()}
            className="inline-flex items-center gap-1.5 text-sm text-accentblue hover:underline" data-testid={testid}>
            <Upload className="h-4 w-4" /> {value ? "Change" : "Upload"}
          </button>
          {value && (
            <button type="button" onClick={() => onChange("")}
              className="inline-flex items-center gap-1 text-sm text-red-500 hover:underline" data-testid={`${testid}-remove`}>
              <X className="h-4 w-4" /> Remove
            </button>
          )}
        </div>
        <input ref={ref} type="file" accept="image/*" className="hidden" onChange={handle} />
      </div>
    </div>
  );
}
